var Stickyfill = require('stickyfilljs');

$(function() {
    const elements = $('.header, .footer, .category-filters, category-filters__form-wrap, .category-map, .global-errors, .information-order__form, .information-sidebar__top, .information-sidebar__option.is-active, .sidebar__wrap, .category-filters__mobile-buttons');

    Stickyfill.add(elements);
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/ie-polyfills/position-sticky.js